import React, { useEffect, useMemo, useRef, useState, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';
import { MebmerAudioItem, MebmerChatItem, MebmerHandlerItem, MebmerVideoItem, MemberEtc } from './MemberItem';
import { MEMBER_STATUS } from './constans';
import { getDisplayNickname, getMemberTrackByUserID } from './functions';
import { getPropertyValue } from '../settings/functions';
const MemberItemContainer = forwardRef(({ user_id, search, isMonitoring }, ref) => {
    const member = useSelector((state) => getMemberTrackByUserID(state, user_id, false), shallowEqual);
    const individualLive = useSelector((state) => getPropertyValue(state, 'individualLive'));
    // 검색 판정도 표시명 기준 — 진행자('조교' 마스킹)의 실명이 검색어로 노출/동작하지 않게 한다
    if (!member || (search && getDisplayNickname(member.nickname, member.role)?.includes(search)))
        return null;
    return (React.createElement("div", { ref: ref },
        React.createElement(MemberItemRender, { member: member, isMonitoring: isMonitoring, individualLive: individualLive })));
});
export default MemberItemContainer;
export const MemberItemRender = React.memo(({ member, isMonitoring = false, individualLive = false, }) => {
    const containerRef = useRef(null);
    const { t } = useTranslation();
    const { user_uuid, nickname, pinned, local: isLocal, role: role_name, chat_disabled, audioMuted, videoMuted, } = useMemo(() => member, [member]);
    // 진행자(manager)는 실명 대신 '조교'로 표기 — 목록 이름·강제퇴장(MemberEtc) 다이얼로그 공통
    const displayNickname = useMemo(() => getDisplayNickname(nickname, role_name), [nickname, role_name]);
    const [changeNick, setChangeNick] = useState(false);
    useEffect(() => {
        const handlerChangenick = () => setChangeNick(!changeNick);
        if (isLocal) {
            APP.eventManager.subscribe('CHANGE_NICKNAME', handlerChangenick);
            return () => {
                APP.eventManager.unsubscribe('CHANGE_NICKNAME', handlerChangenick);
            };
        }
    }, [isLocal, changeNick]);
    return (React.createElement("div", { ref: containerRef, className: `item_member ${isLocal ? 'local' : ''}` },
        React.createElement("div", { className: "member_name_wrapper nonSelect" },
            React.createElement("p", { className: "role" }, t(`role.${role_name}`)),
            React.createElement("span", { className: "name", style: { color: isLocal ? '#8bacff' : '' } },
                ' ',
                !changeNick && (displayNickname || '-'),
                ' ')),
        React.createElement("div", { className: "member_icon_wrapper" }, member.status === MEMBER_STATUS.OCCUPIDE ? (['handler', 'chat', 'mic', 'video', 'etc'].map(item => {
            // if (!APP.config.memberIcon.includes(item)) return null;
            switch (item) {
                case 'handler':
                    if (individualLive)
                        return null;
                    return (React.createElement(MebmerHandlerItem, { key: item, item: item, user_uuid: user_uuid, pinned: pinned, isLocal: isLocal, isMonitoring: isMonitoring }));
                case 'chat':
                    return (React.createElement(MebmerChatItem, { key: item, item: item, isLocal: isLocal, user_uuid: user_uuid, chatDisabled: chat_disabled, isMonitoring: isMonitoring, role_name: role_name }));
                case 'mic':
                    return (React.createElement(MebmerAudioItem, { key: item, item: item, isLocal: isLocal, user_uuid: user_uuid, audioMuted: audioMuted, isMonitoring: isMonitoring }));
                case 'video':
                    return (React.createElement(MebmerVideoItem, { key: item, item: item, isLocal: isLocal, user_uuid: user_uuid, videoMuted: videoMuted, isMonitoring: isMonitoring }));
                case 'etc':
                    return (React.createElement(MemberEtc, { key: item, item: item, role_name: role_name, nickname: displayNickname, user_uuid: user_uuid, videoMuted: videoMuted, isMonitoring: isMonitoring, isLocal: isLocal }));
            }
        })) : (React.createElement("div", null, "\uBBF8 \uCC38 \uC11D")))));
});
